import VisitScreenContainer from '../../features/containers/visits/VisitsScreenContainer';

export default function Visits() {
  return <VisitScreenContainer />;
}
